var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-bottom',{attrs:{"order-list-types":_vm.orderListTypes,"order-search-type":_vm.orderSearchTypes}})}
var staticRenderFns = []

export { render, staticRenderFns }